// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CXXc","delete":"styles_delete__2tWt8","update":"styles_update__2tdOR","add":"styles_add__1zgpx"};